import { Injectable, inject } from '@angular/core';
import { IContextoBardo } from '@nomoh-monorepo/shared-types';
import { LoginResult } from '../models/auth.interface';
import { AuthDataService, LoginRequest } from './auth.dataservice.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private dataService = inject(AuthDataService);

  // Expor signals do DataService
  $user = this.dataService.$user;
  $isAuthenticated = this.dataService.$isAuthenticated;
  $loading = this.dataService.$loading;
  $error = this.dataService.$error;
  $sessionVerified = this.dataService.$sessionVerified;
  $termosPendentes = this.dataService.$termosPendentes;
  $pendingContextosBardo = this.dataService.$pendingContextosBardo;
  $bardoContextoAtivo = this.dataService.$bardoContextoAtivo;

  async login(request: LoginRequest): Promise<LoginResult> {
    return await this.dataService.login(request);
  }

  async selecionarContexto(contexto: IContextoBardo): Promise<boolean> {
    return await this.dataService.selecionarContexto(contexto);
  }

  redirecionarSePlanoBloqueado(): boolean {
    return this.dataService.redirecionarSePlanoBloqueado();
  }

  async marcarPlanoAtivoAposPagamento(): Promise<void> {
    await this.dataService.marcarPlanoAtivoAposPagamento();
  }

  async checkSession(): Promise<void> {
    await this.dataService.checkSession();
  }

  async logout(): Promise<void> {
    await this.dataService.logout();
  }

  async refreshToken(): Promise<boolean> {
    return await this.dataService.refreshToken();
  }
}
